export default {
      id: "icon-passport-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-passport",
      toString: function () {
        return this.url;
      }
    }